import React from "react";
import { Flex, Span } from "@catchoftheday/cg-components";
import { ONEPASS_MONTHLY_PRICE, ONEPASS_YEARLY_PRICE } from "../../../consts";
import { PlanPriceBox } from "./PlanPriceBox";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PlanOptions = function PlanOptions() {
  return ___EmotionJSX(Flex, {
    alignItems: "stretch",
    flex: "1 0 auto",
    pb: 4
  }, ___EmotionJSX(PlanPriceBox, {
    price: ONEPASS_MONTHLY_PRICE,
    interval: "month"
  }), ___EmotionJSX(Flex, {
    alignItems: "center",
    px: 2
  }, ___EmotionJSX(Span, {
    fontSize: "lg",
    fontWeight: "bold"
  }, "OR")), ___EmotionJSX(PlanPriceBox, {
    price: ONEPASS_YEARLY_PRICE,
    interval: "year"
  }));
};